import { Element, ElementInventoryStatus, ElementType, FocusVersionScheduling } from '@/redux/slices/slice_types';

export enum AvailStatus {
  Success = 'success',
  Warning = 'warning',
  Error = 'error'
}

export interface ReadinessElement {
  platform: FocusVersionScheduling['availed_platform'];
  inventory_status: ElementInventoryStatus;
  element_type: ElementType;
  element_subtype: Element['element']['element_subtype'];
  language: Element['element']['language'];
  video_resolution_type?: Element['element']['video_resolution_type'];
}
